import { useMutation } from 'react-query';
import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum';
import { getDataFromLocalStorage } from 'src/localStorage/getDataFromLocalStorage';
import { useNotification } from 'src/providers/notificationsProvider';
import { deleteDynamicLink } from 'src/services/napi/dynamicLinks/deleteDynamicLink';
import { Project } from 'src/services/napi/projects/interfaces/fetchProjects.interface';
import {
  DeleteDynamicLinkMutationFnParams,
  UseDeleteDynamicLinkMutationParams
} from './interfaces/useDeleteDynamicLinkMutation.interface';

const deleteDynamicLinkMutationFn = async ({
  dynamicLinkId
}: DeleteDynamicLinkMutationFnParams): Promise<boolean | undefined> => {
  const currentProject = getDataFromLocalStorage<Project>(LocalStorageKey.CURRENT_PROJECT);
  const { _id: projectId } = currentProject ?? {};

  if (!projectId) return;

  const response = await deleteDynamicLink({ dynamicLinkId, projectId });
  return response?.success;
};

export const useDeleteDynamicLinkMutation = ({
  onError,
  onSuccess
}: UseDeleteDynamicLinkMutationParams) => {
  const { notify } = useNotification();

  return useMutation({
    mutationFn: (data: DeleteDynamicLinkMutationFnParams) => deleteDynamicLinkMutationFn(data),
    onError: () => {
      notify({ message: 'Error Deleting Dynamic Link... Try again later', severity: 'error' });
      onError?.();
    },
    onSuccess: () => {
      notify({ message: 'Dynamic Link Deleted Successfully' });
      onSuccess?.();
    }
  });
};
